import { Helmet } from 'react-helmet-async';

function SEO({ title, description, url, image }) {
  // Valores por defecto si la página no envía propiedades específicas
  const defaultTitle = "SITEV | Software para Centros de Inspección Técnica Vehicular";
  const defaultDesc = "Optimice su CITV con SITEV. Software para centros de inspección técnica vehicular en Perú. Cumple normativas del MTC. Incluye Facturación Electrónica. Soporte técnico permanente.";
  const defaultUrl = "https://www.jcsistemasperu.com";
  const defaultImage = "https://www.jcsistemasperu.com/images/sitev_seo.webp";

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://jcsistemasperu.com",
      "name": "SITEV",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Windows",
      "description": "Sistema Integrado de Inspección Técnica Vehicular desarrollado de acuerdo a los requerimientos y normativas vigentes del Ministerio de Transportes y Comunicaciones (MTC) en Perú.",
      "browserRequirements": "Requires JavaScript. Requires HTML5.",
      "applicationSubCategory": "Software de Gestión para CITV",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "PEN",
        "availability": "https://schema.org",
        "url": "https://jcsistemasperu.com/"
      },
      "featureList": [
        "Soporte multimarca compatible con más de 70 modelos de equipos de inspección como Beissbarth, VTEQ, Cosber, MAHA, Jevol, RymE y mas!.",
        "Facturación electrónica integrada.",
        "Monitoreo en tiempo real via plataforma Sitev DataCentral.",
        "Enlace directo con el MTC.",
        "Archivo Digital documentario y módulo de Expedientes para SUTRAN"
      ]
    },
    {
      "@type": "LocalBusiness",
      "@id": "https://jcsistemasperu.com",
      "name": "JCSistemasPeru",
      "url": "https://jcsistemasperu.com",
      "telephone": "+51984119920",
      "email": "contacto@jcsistemasperu.com",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "PE",
        "addressRegion": "Tacna"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "07:30",
          "closes": "17:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Saturday"],
          "opens": "08:00",
          "closes": "12:00"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/JCSistemasPeru/"
      ]
      }
    ]
  }

  return (
    <Helmet>
        {/* Metadatos Estándar */}
        <meta charset="utf-8" />
        <title>{title ? `${title} | SITEV` : defaultTitle}</title>
        <link rel="canonical" href={url || defaultUrl} />
        <link rel="icon" href={(url || defaultUrl) + "/favicon.jpg"} />
        <link rel="manifest" href={(url || defaultUrl) +"/manifest.json"} /> 
        <meta name="title" content={title ? `${title} | SITEV` : defaultTitle}/>
        <meta name="description" content={description || defaultDesc} />
        <meta name="robots" content="index, follow" />
    
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url || defaultUrl} />
        <meta property="og:title" content={title || defaultTitle} />
        <meta property="og:description" content={description || defaultDesc} />
        <meta property="og:image" content={image || defaultImage} />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title || defaultTitle} />
        <meta name="twitter:description" content={description || defaultDesc} />
        <meta name="twitter:image" content={image || defaultImage} />
        
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
    </Helmet>
  );
}

export default SEO;